<template>
  <div class="row navbar">
    <vue-progress-bar></vue-progress-bar>
    <div class="col-xs navbar__left hover" @click="refreshPage()">
      <div class="sbh-topbar-logo" v-show="applicationTitle"></div>
      <div
        class="sbh-topbar-logo logo-greyout"
        v-show="!applicationTitle"
      ></div>
    </div>
    <div class="col-xs navbar__right">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link navbar__circle">
          <!--span class="user-name-nav">{{user.firstName}}</span-->
          <i class="fas fa-bars"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            @click.native="refreshPage()"
            class="sbh-dropdown desktophide"
          >
            <i class="far fa-building"></i> Parkhaus
          </el-dropdown-item>
          <el-dropdown-item
            @click.native="navigation('userManual')"
            class="sbh-dropdown"
          >
            <i class="far fa-question-circle"></i> Hilfe &amp; Handbuch
          </el-dropdown-item>
          <el-dropdown-item
            @click.native="navigation('settings')"
            class="sbh-dropdown"
          >
            <i class="far fa-fw fa-wrench"></i> Einstellungen
          </el-dropdown-item>
          <el-dropdown-item
            @click.native="$emit('logout')"
            class="sbh-dropdown"
          >
            <i class="far fa-fw fa-sign-out"></i> Abmelden
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import router from "../router";

export default {
  name: "AppNavbar",
  props: {
    applicationTitle: String
  },
  methods: {
    navigation(target) {
      this.$emit("navigation", target);
    },
    refreshPage() {
      router.go({ path: "/main" });
    }
  }
};
</script>
